
var React = require('react');
var ReactDOM = require('react-dom');
var $ = require('jquery')


import { Router, Route, Link, IndexRoute, browserHistory, useRouterHistory } from 'react-router'

// import { createHistory } from 'react-router'
import { createHistory } from 'history'
import { createHashHistory } from 'history'
import { useBasename,useBeforeUnload } from 'history'

// var Router = require('react-router').Router
// var Route = require('react-router').Route
// var Link = require('react-router').Link
// var IndexRoute = require('react-router').IndexRoute

var App = require('./modules/components/App/App')



var Pocetna = require('./modules/components/App/Pocetna')
var Onama = require('./modules/components/Onama/Onama')
var Galerija = require('./modules/components/Galerija/Galerija')
var SlikeGal = require('./modules/components/Galerija/SlikeGal')
var VaznaDokumenta = require('./modules/components/VaznaDokumenta/VaznaDokumenta')
var AkcionarskoDrustvo = require('./modules/components/AkcionarskoDrustvo/AkcionarskoDrustvo')
var SertifikatiOkvalitetu = require('./modules/components/SertifikatiOkvalitetu/SertifikatiOkvalitetu')
var Proizvodi = require('./modules/components/Proizvodi/Proizvodi')
var Reference = require('./modules/components/Reference/Reference')
var Desavanje = require('./modules/components/Desavanje/Desavanje')
var Kontakt = require('./modules/components/Kontakt/Kontakt')
var PDFdoc = require('./modules/components/App/PDFdoc')


class PageNotFound extends React.Component {
  render() {

    return (
      <div className='container text-center'>
        <img className='errorPage' src='img/404.jpg' />
        <p>Go to <Link to="/">Home Page</Link></p>
      </div>
    )
  }
}


const appHistory = useRouterHistory(createHistory)({
    basename: '/',
    queryKey: false
});


var routes = (
    <Router history={appHistory}>
        <Route path={'/'} component={App}>
          <IndexRoute component={Pocetna} />
            <Route path="o-nama" component={Onama}/>
            <Route path="galerija" component={Galerija}/>
            <Route path="galerija/:id" component={SlikeGal}/>
            <Route path="vazna-dokumenta" component={VaznaDokumenta}/>
            <Route path="vazna-dokumenta/:id" component={PDFdoc}/>
            <Route path="akcionarsko-drustvo" component={AkcionarskoDrustvo}/>
            <Route path="akcionarsko-drustvo/:id" component={PDFdoc}/>
            <Route path="sertifikati" component={SertifikatiOkvalitetu}/>
            <Route path="proizvodi" component={Proizvodi}/>
            <Route path="reference" component={Reference}/>
            <Route path="desavanja" component={Desavanje}/>
            <Route path="kontakt" component={Kontakt}/>
        </Route>
        <Route path='/uk/' component={App}>
           <IndexRoute component={Pocetna} />
            <Route path="about-us" component={Onama}/>
            <Route path="gallery" component={Galerija}/>
            <Route path="gallery/:id" component={SlikeGal}/>
            <Route path="certificates" component={SertifikatiOkvalitetu}/>
            <Route path="products" component={Proizvodi}/>
            <Route path="references" component={Reference}/>
            <Route path="contact" component={Kontakt}/>
        </Route>
        <Route path='/de/' component={App}>
           <IndexRoute component={Pocetna} />
            <Route path="uberdas" component={Onama}/>
            <Route path="galerie" component={Galerija}/>
            <Route path="galerie/:id" component={SlikeGal}/>
            <Route path="zertifikate" component={SertifikatiOkvalitetu}/>
            <Route path="produkte" component={Proizvodi}/>
            <Route path="referenzen" component={Reference}/>
            <Route path="kontakt" component={Kontakt}/>
        </Route>
        <Route path="*" component={PageNotFound}/>
    </Router>
)


ReactDOM.render(routes, document.getElementById('app'))








/** WEBPACK FOOTER **
 ** ./index.js
 **/